import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const OpenNewWindow16 = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M13.9999 5.62674V2H10.3732"
      stroke={getColor(color, isColorInherited)}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9997 2L5.99951 10.0002"
      stroke={getColor(color, isColorInherited)}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.60011 4.40002H2.80002C2.37334 4.40002 2 4.77337 2 5.20004V13.2002C2 13.6269 2.37334 14.0002 2.80002 14.0002H10.8002C11.2269 14.0002 11.6002 13.6269 11.6002 13.2002V8.40011"
      stroke={getColor(color, isColorInherited)}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
